<template lang="pug">
  #ItemsListIndex.container-width
    h5.text-center.py-3.letter-spacing-6 我的工作管理
    hr.border.border-primary.w-100
    .p-3.bg-light
      b-card.rounded-0.border-0(
        bg-variant="light",
        v-for="(router,index) in routers",
        :key="index",
        body-class="p-0"
      )
        router-link(
          :to="{name: router.routerPushName ? router.routerPushName : 'sm-items-list-index'}"
        )
          .row.no-gutters.p-3(
            :class="{ 'border-top border-primary': index !== 0 }"
          )
            .col-2.pr-1.text-center
              //- Use Font Awesome Icon
              //- i.fa-lg(
              //-   :class="router.iconClassName",
              //-   style="font-size: 1.5rem;color: #000000;"
              //- )
              b-img(
                :src="router.iconClassName",
                fluid,
                alt="Icon",
                width="35",
                height="35"
              )
            .col-10.pl-1.d-flex.align-items-center
              span(
                style="color: #000000;"
              ) {{ router.name }}
</template>

<script>
import { SM_MSG_MANAGER_INDEX } from '@/router/sm/msg-manager';
import { SM_RESERVATION_INDEX } from '@/router/sm/reservation';
import { SM_CONTACTS_INDEX } from '@/router/sm/contacts';
import { SM_LABEL_INDEX } from '@/router/sm/label';
import { SM_STORES_MANAGER_INDEX } from '@/router/sm/stores-manager';
import { SM_PROFILE_INDEX } from '@/router/sm/profile';
import { SM_QR_CODE_INDEX } from '@/router/sm/qr-code';

import IconMsgManagerUrl from '@/assets/images/icon/icon_msg_manager.png';
import IconReservationUrl from '@/assets/images/icon/icon_reservation.png';
import IconContactsUrl from '@/assets/images/icon/icon_contacts.png';
import IconLabelUrl from '@/assets/images/icon/icon_label.png';
import IconStoreUrl from '@/assets/images/icon/icon_store.png';
import IconProfileUrl from '@/assets/images/icon/icon_profile.png';
import IconQRCodeUrl from '@/assets/images/icon/icon_qrcode_solid.png';

export default {
  name: 'ItemsListIndex',
  data() {
    return {
      routers: [
        {
          name: '訊息管理',
          iconClassName: IconMsgManagerUrl,
          routerPushName: SM_MSG_MANAGER_INDEX
        },
        {
          name: '我的預約',
          iconClassName: IconReservationUrl,
          routerPushName: SM_RESERVATION_INDEX
        },
        {
          name: '我的客戶',
          iconClassName: IconContactsUrl,
          routerPushName: SM_CONTACTS_INDEX
        },
        {
          name: '客戶標籤',
          iconClassName: IconLabelUrl,
          routerPushName: SM_LABEL_INDEX
        },
        {
          name: '店舖管理',
          iconClassName: IconStoreUrl,
          routerPushName: SM_STORES_MANAGER_INDEX
        },
        {
          name: '修改個人資料',
          iconClassName: IconProfileUrl,
          routerPushName: SM_PROFILE_INDEX
        },
        {
          name: '店長qr-code',
          iconClassName: IconQRCodeUrl,
          routerPushName: SM_QR_CODE_INDEX,
          isShow: true
        }
      ]
    };
  },
  mounted() {
    this.$store.commit('toggleLoading', false);
  }
};
</script>

<style>

</style>
